import { Theme } from '@mui/material'

const useStyles = {
  listCard: (theme: Theme) => ({
    borderRadius: '4px',
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none',
  }),
  list: (theme: Theme) => ({
    padding: 0,
    height: '384px',
    backgroundColor: theme.palette.background.paper,
    overflow: 'auto',
  }),
  keyboardChip: (theme: Theme) => ({
    background: theme.palette.grey[50],
    boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 1px 3px rgba(0, 0, 0, 0.12)',
    borderRadius: '4px',
  }),
}
export default useStyles
